import { hasAccessToThisRoute } from '../../utility/helpers';
import { globalEndpoints } from '../../endpoints/global';
import { securityEndpoints } from '../../endpoints/security';
import {
  CLEAR_AUTH_ERROR,
  CURRENT_USER_FETCHED,
  USER_AUTHENTICATED,
  USER_UNAUTHENTICATED,
  CHECK_LOGIN_AVAILABLE,
  CHECK_EMAIL_AVAILABLE,
  UPDATE_PROFILE,
  CHANGE_PASSWORD,
  RESET_SCOPEDROLES,
  GET_SCOPEDROLES,
  USER_SIGN_VALIDATION,
  TRAINING_NOTIFICATION,
  SET_CAPTCHA_INVISIBLE,
  SET_CAPTCHA_NORMAL,
  SET_MFA_TOKEN_TYPE,
} from '../types/security';
import { getData, postData, putData } from '../../utility/mmur_service_com';
import { UserType, UserPermissionsIds, UserStatus } from '../../utility/enumerations';
import { getPatientProfile } from './patient';

export function getCurrentUser() {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.getCurrentUser}`;
  return function (dispatch) {
    const responseData = getData(url, dispatch, CURRENT_USER_FETCHED);
    responseData.then((response) => {
      if (response) {
        // validation to prevent calling the endpoint
        const userHasAccessPermissions = hasAccessToThisRoute(response?.permissions, UserPermissionsIds.ReadPatient);

        if (response.userTypeId === UserType.CardHolder
          && response.patientIdEncrypted
          && !response.passwordExpired
          && response.userStatus.id !== UserStatus.PendingTraining
          && userHasAccessPermissions) {
          dispatch(getPatientProfile(response.patientIdEncrypted, false));
        }
      }
    });
    return responseData;
  };
}

export function passthroughAuthentication() {
  return function (dispatch) {
    dispatch({
      type: USER_AUTHENTICATED,
    });
  };
}

export function setReCaptchaSizeAction(reCaptchaSize: 'normal' | 'compact' | 'invisible') {
  return function (dispatch) {
    if (reCaptchaSize === 'invisible') {
      dispatch({
        type: SET_CAPTCHA_INVISIBLE,
      });
    } else if (reCaptchaSize === 'normal') {
      dispatch({
        type: SET_CAPTCHA_NORMAL,
      });
    }
  };
}

export function authenticateUser(model) {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.authenticate}`;
  const data = {
    username: model.username,
    password: model.password,
    captchaValue: model.captchaValue,
    captchaSize: model.captchaSize,
    mfaCode: model.mfaCode,
    mfaTypeSelection: model.mfaTypeSelection,
    callMqa: true,
    ignoreRecaptcha: model.IgnoreRecaptcha ?? false
  };

  return function (dispatch) {
    dispatch({ type: CLEAR_AUTH_ERROR });
    return postData(url, data, dispatch, USER_AUTHENTICATED);
  };
}

export function authenticateUserSso(data) {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.authenticateSso}`;
  return function (dispatch) {
    dispatch({ type: CLEAR_AUTH_ERROR });
    return postData(url, data, dispatch, USER_AUTHENTICATED);
  };
}

export function unAuthenticateUser() {
  const data = { revokeAll: false };
  const url = securityEndpoints.logout;

  return function (dispatch) {
    return postData(url, data, dispatch, USER_UNAUTHENTICATED);
  };
}

export function checkLoginId(loginId) {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.checkLoginId}?loginId=${loginId}`;
  return function (dispatch) {
    return getData(url, dispatch, CHECK_LOGIN_AVAILABLE);
  };
}

export function checkEmailAddress(emailAddress) {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.checkEmailAddress}?emailAddress=${emailAddress}`;
  return function (dispatch) {
    return getData(url, dispatch, CHECK_EMAIL_AVAILABLE);
  };
}

export function updateProfile(model) {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.updateProfile}`;
  const data = { loginId: model.loginId, emailAddress: model.emailAddress };
  return function (dispatch) {
    return putData(url, data, dispatch, UPDATE_PROFILE);
  };
}

export function changePassword(model) {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.changePassword}`;
  const data = { currentPassword: model.currentPassword, newPassword: model.confirmNewPassword };
  return function (dispatch) {
    return putData(url, data, dispatch, CHANGE_PASSWORD);
  };
}

export function saveMfaTokenType(mfaTokenTypeId) {
  return function (dispatch) {
    dispatch({ type: SET_MFA_TOKEN_TYPE, payload: mfaTokenTypeId });
  };
}

export function clearAuthError() {
  return function (dispatch) {
    dispatch({ type: CLEAR_AUTH_ERROR });
  };
}

export const getScopedRoles = () => async (dispatch) => {
  dispatch({
    type: RESET_SCOPEDROLES,
  });
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.scopedRoles}`;
  return getData(url, dispatch, GET_SCOPEDROLES);
};

export const dismissTrainingNotification = (data) => (dispatch) => {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.dismissTrainingNotification}`;
  return putData(url, data, dispatch, TRAINING_NOTIFICATION);
};

export const newUserSignature = (data) => (dispatch) => {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.signatureValidation}`;
  return putData(url, data, dispatch, USER_SIGN_VALIDATION);
};

export function submitForgotPassword(model) {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.forgotPassword}`;
  const data = { LoginId: model.loginId };

  return function (dispatch) {
    return putData(url, data, dispatch, null);
  };
}

export function submitResetPassword(model) {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.resetPassword}`;

  return function (dispatch) {
    return putData(url, model, dispatch, null);
  };
}

export function submitRegistrationCheck(model) {
  const url = `${globalEndpoints.apiUrl}${securityEndpoints.registrationCheck}`;
  const data = { LoginId: model.loginId };

  return function (dispatch) {
    return putData(url, data, dispatch, null);
  };
}
